/**
 * Bloomyer Blog Catégories — indicateur de scroll (pilules allongées)
 * Figma node 3414:21200
 */
(function () {
  function init(section) {
    const trackWrap = section.querySelector('.bbcat-track-wrap');
    const dotsContainer = section.querySelector('.bbcat-dots');
    if (!trackWrap || !dotsContainer) return;

    let dots = [];
    let pages = 1;

    function getMaxScroll() {
      return Math.max(0, trackWrap.scrollWidth - trackWrap.clientWidth);
    }

    function buildDots() {
      const maxScroll = getMaxScroll();
      pages = maxScroll <= 0 ? 1 : Math.min(5, Math.ceil(trackWrap.scrollWidth / trackWrap.clientWidth));

      if (pages <= 1) {
        dotsContainer.innerHTML = '';
        dotsContainer.style.display = 'none';
        dots = [];
        return;
      }

      dotsContainer.style.display = '';
      dotsContainer.innerHTML = '';
      for (let i = 0; i < pages; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bbcat-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Aller au groupe ' + (i + 1));
        dot.addEventListener('click', () => {
          const maxScroll = getMaxScroll();
          trackWrap.scrollTo({
            left: maxScroll * (i / (pages - 1)),
            behavior: 'smooth',
          });
        });
        dotsContainer.appendChild(dot);
      }
      dots = [...dotsContainer.querySelectorAll('.bbcat-dot')];
      updateActiveDot();
    }

    function updateActiveDot() {
      if (!dots.length) return;
      const maxScroll = getMaxScroll();
      const ratio = maxScroll > 0 ? trackWrap.scrollLeft / maxScroll : 0;
      const activeIdx = Math.round(ratio * (dots.length - 1));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIdx));
    }

    let scrollTicking = false;
    trackWrap.addEventListener('scroll', () => {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(() => {
        updateActiveDot();
        scrollTicking = false;
      });
    });

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildDots, 200);
    });

    buildDots();
  }

  function ready() {
    document.querySelectorAll('.bbcat-section').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
